import React, { useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { Add } from 'iconsax-react';
import { Tendina, Interruttore } from './campi';
import { mani, piedi } from './modificaAnagrafica';
import { practicedSportsRoles } from '../../Util/enum';
import { sportLabel, useSportsCatalog } from '../../Util/sportsCatalog';
import CampoRicerca from '../../Util/CampoRicerca';
import chiediConferma from '../../Util/chiediConferma';

/*
 * Tab dei dati sportivi in modifica (player: «Dati sportivi», junior: «Sport»): mano e piede, assicurazione e sport praticati.
 *
 * Sport praticati: l'elenco si salva intero con Salva (sostituisce quello di prima, PATCH ... sports).
 * - Ruolo: solo per gli sport che lo prevedono (practicedSportsRoles, gli stessi che accetta il backend); una volta scelto
 *   si cambia ma non si toglie (lo schema non accetta un ruolo vuoto).
 * - Gli sport insegnati (con il tesserino) non si rimuovono da qui: il backend li tiene comunque.
 */

const SportPraticati = ({ valori, onChange, info }) => {
    const catalogo = useSportsCatalog();
    const [nuovo, setNuovo] = useState('');

    const disponibili = catalogo.filter((s) => !valori.some((x) => x.sportType === s.value));

    const ruoliDi = (sportType, attuale) => {
        const ruoli = practicedSportsRoles[sportType] || [];
        return attuale && !ruoli.some((r) => r.value === attuale) ? [...ruoli, { value: attuale, label: attuale }] : ruoli;
    };

    const aggiungi = () => {
        if (!nuovo || valori.some((x) => x.sportType === nuovo)) return;
        onChange([...valori, { sportType: nuovo, sportRole: '' }]);
        setNuovo('');
    };

    const rimuovi = async (s) => {
        const nome = sportLabel(s.sportType);
        if (!(await chiediConferma({ titolo: `Rimuovere ${nome}?`, testo: 'Lo sport sparisce dagli sport praticati quando salvi la scheda.', conferma: 'Rimuovi' }))) return;
        onChange(valori.filter((x) => x.sportType !== s.sportType));
    };

    const cambiaRuolo = (sportType, sportRole) => onChange(valori.map((x) => (x.sportType === sportType ? { ...x, sportRole } : x)));

    return (
        <>
            {valori.length === 0 && <p className="sid-nota-leggibile mb-3">Nessuno sport praticato.</p>}
            {valori.map((s) => {
                const dati = info[s.sportType] || {};
                const ruoli = ruoliDi(s.sportType, s.sportRole);
                return (
                    <Row className="g-3 align-items-end mb-3" key={s.sportType}>
                        <Col sm={5}>
                            <Form.Label as="span">Sport</Form.Label>
                            <div className="sid-readonly-value">
                                {sportLabel(s.sportType)}
                                {typeof dati.livello === 'number' ? ` · livello ${dati.livello.toFixed(0)}%` : ''}
                                {dati.insegnato ? ' · insegnato' : ''}
                            </div>
                        </Col>
                        {ruoli.length > 0 ? (
                            <Tendina
                                id={`ruolo-${s.sportType}`}
                                etichetta="Ruolo"
                                opzioni={ruoli}
                                valore={s.sportRole}
                                onChange={(v) => cambiaRuolo(s.sportType, v)}
                                larghezza={4}
                            />
                        ) : <Col sm={4} className="d-none d-sm-block" />}
                        <Col sm={3}>
                            {!dati.insegnato && (
                                <button type="button" className="btn btn-outline-danger sid-btn-compatto mb-2" onClick={() => rimuovi(s)}>Rimuovi</button>
                            )}
                        </Col>
                    </Row>
                );
            })}
            <Row className="g-3 align-items-end">
                <Col sm={8}>
                    <Form.Label htmlFor="sa-sport-nuovo">Aggiungi uno sport</Form.Label>
                    <CampoRicerca id="sa-sport-nuovo" opzioni={disponibili} valore={nuovo} onChange={setNuovo} minCaratteri={2} massimo={10} />
                </Col>
                <Col sm={4}>
                    {nuovo && (
                        <Button className="btn btn-primary sid-btn-compatto mb-2" onClick={aggiungi}>
                            <Add size={14} /><span>Aggiungi sport</span>
                        </Button>
                    )}
                </Col>
            </Row>
        </>
    );
};

/** Props: modifica (useModificaAnagrafica). */
const DatiSportiviModifica = ({ modifica }) => {
    const { f, imposta, infoSport } = modifica;
    const campo = (chiave) => ({ id: chiave, valore: f[chiave], onChange: (v) => imposta(chiave, v) });

    return (
        <Card>
            <Card.Body className="sid-card-body--spaced">
                <h5 className="sid-form-section">Informazioni generiche</h5>
                <Row className="g-4">
                    <Tendina {...campo('primaryHand')} etichetta="Mano primaria" opzioni={mani} larghezza={4} />
                    <Tendina {...campo('primaryFoot')} etichetta="Piede primario" opzioni={piedi} larghezza={4} />
                    <Interruttore {...campo('insured')} etichetta="Assicurato" larghezza={4} />
                </Row>

                <h5 className="sid-form-section">Sport praticati</h5>
                <SportPraticati valori={f.sports} onChange={(v) => imposta('sports', v)} info={infoSport} />
            </Card.Body>
        </Card>
    );
};

export default DatiSportiviModifica;
